// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e5501826","636":"563e8c20"}[chunkId] + ".chunk.js";
};